import dayjs from "dayjs";
import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;


const initState = {
    selectedHospitalIds: ["ALL"],
    selectedDistrictIds: ["ALL"],
    loadingCount: 0,
    pageable: {
        limit: 20,
        current: 1,
        total: 0,
    },
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};

export default viewModel;
